// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#background[data-v-e3175d52]{background-image:linear-gradient(90deg,#470048,#1b78d8);width:100%;height:600px;position:absolute;top:0;left:0;right:0;z-index:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
